import { Account } from '@zapier/shared-entities';
import { useRedux } from '@zapier/toolbox-redux-framework';
import { upgradeReasons } from '@zapier/upsells';

export type SelectedAccount = {
  id: number;
  isFree: boolean;
  isTrialing: boolean;
  isTrialingCompanies: boolean;
  isTrialingTeams: boolean;
  trialEndDate: string | number | Date;
  canExtendTrial: boolean;
  didExtendTrial: boolean;
  planId: number;
  chatEligibility: boolean;
};

const REASON = upgradeReasons.emailSupport;

const mapStateToProps = state => {
  const isLoading = !Account.selectors.all.hasCurrentAccountInitialized(state);

  const currentAccount = isLoading
    ? undefined
    : Account.selectors.all.currentAccount(state);

  return {
    account: currentAccount && {
      id: Account.selectors.id(currentAccount),
      isFree: Account.selectors.isFree(currentAccount),
      isTrialing: Account.selectors.isTrialing(currentAccount),
      isTrialingCompanies: Account.selectors.isTrialingCompanies(
        currentAccount
      ),
      isTrialingTeams: Account.selectors.isTrialingTeams(currentAccount),
      trialEndDate: Account.selectors.trialEndDate(currentAccount),
      canExtendTrial:
        Account.selectors.isFree(currentAccount) &&
        !Account.selectors.hasExtendedTrialFor(REASON, currentAccount),
      didExtendTrial: Account.selectors.didExtendTrial(currentAccount),
      planId: Account.selectors.all.currentPlanId(state),
      chatEligibility: Account.selectors.isChatEligible(currentAccount),
    },
    isLoading,
  };
};

const useCurrentAccount = (): {
  account?: SelectedAccount;
  isLoading: boolean;
} => useRedux(mapStateToProps);

export default useCurrentAccount;
